const anonJwtLocalhost =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0';
const publishableDevelopment = 'sb_publishable_pPtjYmxu7HqcZ7iPTn8cHw_iQnU4Glu';
const publishableProduction = 'sb_publishable_jM_yoDIDnnmoFavYNVQQsg_oZligcma';

export const SupabaseKey = {
  Development: publishableDevelopment,
  Localhost: anonJwtLocalhost,
  Production: publishableProduction,
} as const;

export type SupabaseKey = (typeof SupabaseKey)[keyof typeof SupabaseKey];
